import { Route, Switch } from "react-router-dom";

import CsCenterInquiryComponent from "../../components/page/csCenter/csCenterInquiryComponent";
import InquiryManageComponent from "../../components/page/inquiry/InquiryManageComponent";
import NutrientsGPTComponent from "../../components/page/inquiry/NutrientsGPTComponent";
import ProductInquiryComponent from "../../components/page/inquiry/ProductInquiryComponent";
import RecommendInquiryBoardComponent from "../../components/page/inquiry/RecommendInquiryBoardComponent";
import ReviewComponent from "../../components/page/review/ReviewComponent";

const InquiryPage = () => {
  return (
    // <div className="contentPage" style={{ margin: 24 }}>
    <Switch>
      <Route path="/inquiries/product" component={ProductInquiryComponent} />
      <Route path="/inquiries/review" component={ReviewComponent} />
      <Route path="/inquiries/service" component={CsCenterInquiryComponent} />
      <Route
        path="/inquiries/board"
        component={RecommendInquiryBoardComponent}
      />
      <Route path="/inquiries/gpt" component={NutrientsGPTComponent} />
      <Route exact path="/inquiries/view" component={InquiryManageComponent} />
    </Switch>
    // </div>
  );
};

export default InquiryPage;
